import React from 'react';
import axios from 'axios';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import VideoCard from './video_card.jsx';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    width: '100%',
  },
  headerPanel: {
   background: 'purple',
   width: '100%',
   display: 'flex',
   flexDirection: 'row',
  },
  column: {
    width: '25%',
    alignItems: 'center',

      display: 'inline-block',
    flexBasis: '25%',
  },
  gridContainer: {
      marginTop: '15px',
  },
  videosList: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-around',
      flexFlow: 'row wrap',

      listStyleType: 'none',
      paddingLeft: 0,
  },
});

class Videos extends React.Component {
    state = {
        videos: [],
        loading: true
    }

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/videos`)
            .then(res => {
                const videos = res.data;
                this.setState({ videos, loading: false });
            })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Typography variant="headline">Videos</Typography>
                <Typography variant="subheading">These videos have been ingested</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    {this.state.videos.map((video, i) => 
                        <Grid item key={i}>
                            <VideoCard video={video}  />
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(Videos);



// WEBPACK FOOTER //
// ./src/components/videos.jsx